<template>
  <div class="container mt-5">
    <div class="text-center verification-success">
      <div v-if="user && user.firstName" class="mb-4">
        <h1>Welcome, {{ user.firstName }}!</h1>
      </div>
      <svg class="success-icon" viewBox="0 0 16 16">
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
      </svg>
      <h2 class="mt-4">Email Verified Successfully!</h2>
      <p class="lead mt-3">Thank you for verifying your email address. Your account is now fully activated.</p>
      <div class="mt-4">
        <router-link to="/" class="btn btn-primary btn-lg">
          Go to Home Page
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'EmailVerified',
  computed: {
    ...mapState({
      user: state => state.user,
    }),
  },
  created() {
    // Set expiration to 24 hours from now
    const expiration = new Date();
    expiration.setHours(expiration.getHours() + 24);
    
    this.fetchUserData();
    console.log("Logging user in");
    this.login(expiration.toISOString());

  },
  methods: {
    ...mapActions(['setUser', 'login']),
    async fetchUserData() {
      try {
        const response = await fetch(this.$API_BASE_URL + '/api/customers/whoami', {
          method: 'GET',
          credentials: "include", // Ensures cookies are sent with the request
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          this.setUser(data);
          console.log("User data fetched successfully:", data);
        } else {
          console.error('Failed to fetch user information');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }
}
</script>

<style scoped>
.verification-success {
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.success-icon {
  width: 4rem;
  height: 4rem;
  color: #28a745;
}

.lead {
  color: #6c757d;
}

.btn-primary {
  padding: 0.75rem 2rem;
  font-size: 1.1rem;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
